// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import jQuery from 'jquery';
import Popper from 'popper.js';
import axios from 'axios';
import VueAxios from 'vue-axios';


window.$ = window.jQuery = jQuery;
window.Popper = Popper;
global.axios = axios;
global.vue = VueAxios;
global.EventBus = new Vue();


let Bootstrap = require('bootstrap-material-design');
import 'bootstrap-material-design/dist/css/bootstrap-material-design.min.css';
import {Quill} from "vue2-editor";
import {ImageDrop} from "quill-image-drop-module";
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'

window.toastr = require('toastr');
global.toastr = require('toastr');

// import ImageResize from "quill-image-resize-module";
// Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/imageDrop", ImageDrop);
Vue.use(Bootstrap, VueAxios, axios, Quill, VueToastr2);

Vue.config.productionTip = false;

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
});

new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js